import { defineComponent, toRef } from 'vue';
import ExpandableContent from './ExpandableContent.class';

export default defineComponent({
	props: {
		expanded: {
			type: Boolean,
			required: true
		}
	},

	setup: (props) => {
		const component = new ExpandableContent(toRef(props, 'expanded'));
		
		return {
			text: component.staticContentText,
			urls: component.staticContentUrls,
			isPortalTypeMasters: component.isPortalTypeMasters,
			expanded: component.expanded
		};
	},
});